import React, { HTMLAttributes } from 'react';
import Slider, { Settings } from 'react-slick';
import { homeBannerSettings } from 'config/settingsSlider';

import { SliderWrapper } from './style';
import ArrowLeft from 'assets/icon/arrow-left.svg';
import ArrowRight from 'assets/icon/arrow-right.svg';

type Props = {
  settings?: Settings;
};

const SliderDefault: React.FC<Props> = ({ children, settings }) => {
  const SampleNextArrow = (props: HTMLAttributes<HTMLDivElement>) => {
    const { onClick } = props;
    return (
      <div className="arrow next" onClick={onClick}>
        <img src={ArrowRight} alt="Next" />
      </div>
    );
  };

  const SamplePrevArrow = (props: HTMLAttributes<HTMLDivElement>) => {
    const { onClick } = props;
    return (
      <div className="arrow prev" onClick={onClick}>
        <img src={ArrowLeft} alt="Prev" />
      </div>
    );
  };

  return (
    <SliderWrapper>
      <Slider
        {...settings}
        nextArrow={<SampleNextArrow />}
        prevArrow={<SamplePrevArrow />}
      >
        {children}
      </Slider>
    </SliderWrapper>
  );
};

export default SliderDefault;
